import { css, CSSObject } from '@emotion/react'
import { Color, Spacing, Theme } from '@opallabs/gem'

export const emojiButtonOverrides: CSSObject = {
  // chrome doesn't render frowning face correctly in
  // sans-serif fonts
  fontFamily: 'serif',
  // Fix height and width since the serif font used
  // may not be consistent
  height: 32,
  width: 36,
}

export const emojiContent = css({
  padding: Spacing.XS * 3,
})

export const emojiList = css({
  display: 'flex',
  flexFlow: 'row wrap',
  gap: Spacing.XS,
  width: 196,
})

export const header = (theme: Theme) =>
  css({
    color: Color[theme].Text.Gray,
    display: 'flex',
    columnGap: Spacing.S,
    height: 30,
    padding: Spacing.XS,
  })

export const highlightedEmoji = css({
  fontFamily: 'serif',
  fontSize: '24px',
})
